import {
  Text,
  IconMagnifyingGlass,
  GreyGrey40,
  GreyGrey50,
  GreyGrey60,
  GreyWhite,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { useGlobalSearchState } from './useGlobalSearchShortcut'

/**
 * Search affordance for the navigation header that opens the command palette.
 * Collapses to an icon-only button when the sidebar is collapsed.
 */
export const GlobalSearchTrigger = ({
  isCollapsed = false
}: {
  isCollapsed?: boolean
}) => {
  const { setIsOpen } = useGlobalSearchState()

  return (
    <Flex
      as="button"
      type="button"
      aria-label="Search"
      onClick={() => setIsOpen(true)}
      data-testid="global-search.trigger"
      alignItems="center"
      gap="8px"
      width={isCollapsed ? '32px' : '100%'}
      height="32px"
      paddingX="8px"
      borderRadius="6px"
      border={`1px solid ${GreyGrey40}`}
      background={GreyWhite}
      color={GreyGrey60}
      justifyContent={isCollapsed ? 'center' : 'flex-start'}
      _hover={{ border: `1px solid ${GreyGrey50}` }}
    >
      <IconMagnifyingGlass />
      {!isCollapsed && (
        <>
          <Text
            {...Primary13Regular}
            flex="1"
            textAlign="left"
            color={GreyGrey60}
          >
            Search
          </Text>
          <Text {...Primary13Regular} color={GreyGrey50}>
            ⌘K
          </Text>
        </>
      )}
    </Flex>
  )
}
